
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(252|398|483|887)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
